module.exports = __webpack_public_path__ + "202408221624/img/home_summer_2.f01e03b2.png";